<template>
  <div>
    <el-dialog
        v-el-drag-dialog
        :visible.sync="dialogVisible"
        :close-on-click-modal="false"
        title="统计完好率"
        width="500px"
        top="10vh"
        @close="$reset('form')">
      <el-form
          ref="form"
          :model="exportWHL"
          :rules="ruleValidate"
          class="form"
          label-width="120px">
        <el-form-item label="年份" prop="exportYears">
          <el-date-picker
              v-model="exportWHL.exportYears"
              type="year"
              value-format="yyyy"
              placeholder="选择日期"/>
        </el-form-item>
        <!-- <el-form-item label="结束时间" prop="exportEndTime">
         <el-date-picker
             v-model="exportWHL.exportEndTime"
             align="right"
             type="date"
             placeholder="选择结束日期"
             value-format="yyyy-MM-dd HH:mm:ss"/>
       </el-form-item> -->
        <el-form-item label="类型" prop="cycleNum">
          <el-select v-model="exportWHL.cycleNum" style="width: 220px" clearable placeholder="请选择">
            <el-option
                v-for="item in cycleNums"
                :key="item.value"
                :label="item.label"
                :value="item.value"/>
          </el-select>
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button @click="dialogVisible=false">取消</el-button>
        <el-button :loading="exportLoading" type="primary" @click="exportExcel">导出</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
  import constant from "../../../util/constant";

  export default {
    name:"ExportWHLEdit",
    components: {},
    data() {
      return {
        dialogVisible: false,
        exportLoading: false,
        constant,
        cycleNums: constant.toSelect(constant.cycleNum),
        exportWHL: {
          exportYears: "",
          cycleNum: "",
        },
        ruleValidate: {
          exportYears: {required: true, message: "不能为空", trigger: "blur"},
          cycleNum: {required: true, message: "不能为空", trigger: "blur"},
        },
      };
    },
    methods: {
      open() {
        this.dialogVisible = true;
      },
      exportExcel() {
        this.exportLoading = true;
        this.$http
          .exportFile("basic","repairOrders/exportWHL", this.exportWHL)
          .then(res => {
            console.log(res);
            let blob = new Blob([res.data]);
            let fileName = decodeURI(res.headers.filename);
            if (window.navigator && window.navigator.msSaveOrOpenBlob) {
              navigator.msSaveBlob(blob, fileName);
            } else {
              let a = document.createElement("a");
              a.href = URL.createObjectURL(blob);
              a.download = fileName;
              a.style.display = "none";
              document.body.appendChild(a);
              a.click();
              URL.revokeObjectURL(a.href);
              document.body.removeChild(a);
            }
            this.exportLoading = false;
          })
          .catch(() => {
            this.exportLoading = false;
          });
      },
    },
  };
</script>

<style lang="scss" scoped>
</style>
